


export default function TournamentDashboard() {


    return (

        <div className='auth-wrapper'>
            <div className='auth-inner' style={{marginTop: "5rem"}}>

                <h1 style={{textAlign: "center"}}>Tournaments feature is coming Soon :)</h1>
            
            </div>
        </div>

    )
}